import { Dialog } from '@headlessui/react';
import { Lock } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface LockNoticeProps {
  open: boolean;
  onClose: () => void;
}

export function LockNotice({ open, onClose }: LockNoticeProps) {
  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      className="relative z-50"
    >
      <div className="fixed inset-0 bg-black/30" aria-hidden="true" />
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <Dialog.Panel className="mx-auto max-w-md w-full rounded-lg bg-white dark:bg-gray-800 p-6">
          <div className="flex items-center gap-4 mb-4">
            <div className="p-3 rounded-full bg-red-100 dark:bg-red-900/20">
              <Lock className="h-6 w-6 text-red-600 dark:text-red-400" />
            </div>
            <Dialog.Title className="text-lg font-medium text-gray-900 dark:text-white">
              Site Locked
            </Dialog.Title>
          </div>

          <Dialog.Description className="text-gray-500 dark:text-gray-400 mb-6">
            This site is currently locked by the administrator. Please try again later or contact support for assistance.
          </Dialog.Description>

          <div className="flex justify-end">
            <Button onClick={onClose}>
              Close
            </Button>
          </div>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
}